<template>
  <div class="rt-timeline">
    <ul
      :class="{
        'el-timeline': true,
        'is-reverse': reverse
      }"
    >
      <slot></slot>
    </ul>
    <rt-button-more
      v-if="steps.length > displayCount"
      class="rt-xpc-timeline-more"
      expanded-suffix-icon="rt-base-arrow-up-lined"
      collapsed-suffix-icon="rt-base-arrow-down-lined"
      @change="changeExpand"
    ></rt-button-more>
  </div>
</template>
<script>
import RtButtonMore from '../button/rtButtonMore.vue';

export default {
  name: 'RtTimeline',

  components: {
    RtButtonMore
  },

  props: {
    reverse: {
      type: Boolean,
      default: false
    },
    displayCount: {
      type: Number,
      default: 5
    }
  },

  data () {
    return {
      steps: [],
      slots: this.$slots.default || []
    };
  },
  watch: {
    steps (steps) {
      steps.forEach((child, index) => {
        child.index = index;
        if (index > this.displayCount - 1) {
          child.isExpand = false;
        }
      });
    }
  },
  created () {
    if (this.reverse) {
      this.slots = this.slots.reverse();
    }
  },
  methods: {
    changeExpand (isExpand) {
      this.steps.forEach((child, index) => {
        if (index > this.displayCount - 1) {
          child.isExpand = isExpand;
        }
      });
    }
  },

  provide () {
    return {
      timeline: this
    };
  }
};
</script>



// WEBPACK FOOTER //
// rtTimeline.vue?3c28a16c